module.exports = __webpack_public_path__ + "static/media/fourplex_orange.69b9d078.svg";